import React, { createContext, useMemo } from "react"
import PropTypes from "prop-types"

export const ConfigContext = createContext({})

export const ConfigProvider = ({ configData, children }) => {
  const memoizedConfig = useMemo(() => configData ?? {}, [configData])

  return (
    <ConfigContext.Provider value={memoizedConfig}>
      {children}
    </ConfigContext.Provider>
  )
}

ConfigProvider.propTypes = {
  configData: PropTypes.any.isRequired,
  children: PropTypes.node.isRequired,
}
